import React, { useEffect, useState } from 'react';
import { marked } from 'marked';
import './MarkdownStyles.css'


const MarkdownRenderer = ({ filePath }) => {
  const [content, setContent] = useState('');
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    fetch(filePath)
      .then((response) => response.text())
      .then((text) => {
        setContent(text);
        // Configure marked options
        marked.setOptions({
          gfm: true, // Enable GitHub Flavored Markdown
          breaks: true, // Convert line breaks to <br>
        });
        
        // Parse markdown to HTML
        const html = marked.parse(text);
        
        // Remove links by replacing <a> tags with just their text content
        const htmlWithoutLinks = html.replace(/<a[^>]*>(.*?)<\/a>/g, '$1');
        
        setHtmlContent(htmlWithoutLinks);
      });
  }, [filePath]);

  return <div
    className="markdown-content"
    dangerouslySetInnerHTML={{ __html: htmlContent }}
  />;
};

export default MarkdownRenderer;